import { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './assets/css/style.scss';
import Footer from './components/Footer';
import Header from './components/Header';
import SideBar from './components/SideBar';
import CharactersPage from './pages/CharacterPage';
import HomePage from './pages/Home';
import PostsPage from './pages/PostsPage';
import PostDetailsPage from './pages/PostsPage/PostDetailsPage';
import TermPage from './pages/TermPage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

function App() {
  // const [showNavigate, setShowNavigate] = useState(true);

  return (
    <BrowserRouter>
      <Header />
      <SideBar />
      {/* {showNavigate && <NavigateEvent onHide={() => setShowNavigate(false)} />} */}
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/posts/:postType' element={<PostsPage />} />
        <Route path='/posts/:postType/:postPath/:postId' element={<PostDetailsPage />} />
        <Route path='/characters' element={<CharactersPage />} />
        <Route path='/dieu-khoan' element={<TermPage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}

root.render(<App />);